module.exports = __webpack_public_path__ + "img/tramite3.fe5194fb.svg";